import * as Sentry from '@sentry/vue'

const YOUTUBE_PLAYER_SRC = 'https://www.youtube.com/iframe_api'

let scriptTag

let cache

export default async function ensureYoutube() {
  if (cache != null) return cache
  if (global.YT?.Player) {
    cache = global.YT.Player
    return cache
  }
  if (!scriptTag) {
    scriptTag = [...document.querySelectorAll('script')].find(script => script.src === YOUTUBE_PLAYER_SRC)
  }
  if (!scriptTag) {
    scriptTag = document.createElement('script')
    scriptTag.src = YOUTUBE_PLAYER_SRC
    scriptTag.async = true
  }
  cache = new Promise((resolve, reject) => {
    global.onYouTubeIframeAPIReady = () => {
      if (global.YT?.Player) {
        cache = global.YT.Player
        resolve(cache)
      } else {
        cache = Promise.reject(new Error('youtube loaded, but api is missing'))
        reject(cache)
      }
    }

    scriptTag.addEventListener('error', e => {
      console.error('Failure loading youtube player', e)
      Sentry.captureException(e)
      cache = Promise.reject(e)
      reject(cache)
    })
  })
  if (!scriptTag.parentNode) {
    document.head.appendChild(scriptTag)
  }
  return cache
}
